import { Box } from '@mui/material';
import React from 'react';

import { Grid } from '../Grid/Grid';

export interface ImageProps {
  id?: string;
  aspectRatio: string;
  children: React.ReactElement | React.ReactElement[];
}

export const Images: React.FC<ImageProps> = ({ aspectRatio, children, ...props }: ImageProps) => {
  const itemWidth = 12 / (Array.isArray(children) ? children.length : 1);

  return (
    <Grid container spacing={{ xs: 7, lg: 9 }} {...props}>
      {React.Children.map(children, (child) => {
        return (
          <Grid size={itemWidth}>
            <Box sx={{ position: 'relative', aspectRatio }}>{child}</Box>
          </Grid>
        );
      })}
    </Grid>
  );
};
